import {axiosConsumerAppInstance} from "~/api/ConsumerApiManager";
import {AxiosResponse} from "axios";
import {BaseQueryOptions, BaseUseQueryResult, useBaseQuery} from "@bounce/shared/requests";

type Variables = Record<string, never>;

type Data = {
  phone_number: string;
  email: string;
};

export const getContactDetail = async (): Promise<Data> => {
  const result = await axiosConsumerAppInstance.get<Data, AxiosResponse<Data>>(`/user/contact_details`);
  return result.data;
};

export const useGetContactDetailQuery = (
  variables: Variables,
  options?: BaseQueryOptions<Data, Variables>
): BaseUseQueryResult<Data> => {
  return useBaseQuery<Data, Variables>(
    ["user", "communication", "details"],
    getContactDetail,
    variables,
    options
  );
};
